export const getAppVersion = (): string => {
  return __APP_VERSION__
}
